import React, { useCallback } from "react";
import { Header, Img, Logo, LogoutIcon } from "./style";
import LogoFiec from "../../assets/images/fiec-logo.png";
import { useNavigate } from "react-router-dom";
import { Nav, Bars, NavResponsive, NavMenu, NavLink, Logoperfil } from "././././style.js";
import api from "../../Services/api";
import { Authenticator, AuthenticatorSec, AuthenticatorCoordenador, AuthenticatorProfessor } from "../../auth";

export default function Navbar(props) {
  const Navigate = useNavigate();
  const token = localStorage.getItem("token");

  const LogVerify = useCallback(() => {
    api
      .get("/autenticar-token", token)
      .then((res) => {
        if (res.data.perfil === "aluno") {
          if (window.location.href.includes("/aluno")) {
            window.location.reload();
          }
          Navigate("/aluno");
        } else if (res.data.perfil === "usuario" || res.data.perfil === "secretaria") {
          if (window.location.href.includes("/secretaria")) {
            window.location.reload();
          }
          Navigate("/secretaria");
        } else if (res.data.perfil === "coordenador") {
          if (window.location.href.includes("/coordenador")) {
            window.location.reload();
          }
          Navigate("/coordenador");
        } else if (res.data.perfil === "professor") {
          if (window.location.href.includes("/professor")) {
            window.location.reload();
          }
          Navigate("/professor");
        } else {
          localStorage.clear();
          Navigate("/");
        }
      })
      .catch((err) => {
        if (window.location.href.includes("/  ")) {
          window.location.reload();
        }
        localStorage.clear();
        Navigate("/");
      });
  }, [Navigate, token]);

  function Logout() {
    if (
      AuthenticatorSec() == true ||
      Authenticator() == true ||
      AuthenticatorCoordenador() == true ||
      AuthenticatorProfessor() == true
    ) {
      return (
        <LogoutIcon
          onClick={() => {
            localStorage.clear();
            Navigate("/");
          }}
          title="Sair"
        />
      );
    }
  }

  return (
    <Header>
      <Logo>
        <Img onClick={() => LogVerify()} tabIndex={98} src={LogoFiec} alt="LOGO DA FIEC" />
      </Logo>
      <Logout />
      {/* <NavMenu>
        <NavLink tabIndex={99} onClick={() => (window.location.href = "https://alunos.tawk.help")} target={"_blank"}>
          Ajuda ?
        </NavLink>
      </NavMenu> */}
    </Header>
  );
}
